export function normalizeWhatsAppPhoneNumber(value: string) {
  const phoneNumber = value.replace(/\D/g, "");
  return /^[1-9]\d{7,14}$/.test(phoneNumber) ? phoneNumber : null;
}
